<template>
  <InputSelectLanguage
    v-model="currentLocale"
    variant="tiny"
    @update:model-value="changeLanguage"
  />
</template>

<script lang="ts" setup>
import { changeLanguage } from '@backmarket/nuxt-module-i18n/changeLanguage'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

// TODO: fix this when locale format will be uniformized
const currentLocale = useI18nLocale()
</script>
